var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstellationYellowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.483 27.3954V9.13232L27.2148 18.2639L32.483 27.3954Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.87243 9.12779L0.872429 27.3909L6.14063 18.2593L0.87243 9.12779Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6783 0.00138275L0.873715 9.13292L11.4101 9.13292L16.6783 0.00138275Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6792 36.5282L32.4837 27.3966L21.9473 27.3966L16.6792 36.5282Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6791 0.00138399L32.4837 9.13293L21.9473 9.13292L16.6791 0.00138399Z",
    fill: "#FFCC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6788 36.5275L0.874198 27.396L11.4165 27.396L16.6788 36.5275Z",
    fill: "#FFCC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1432 18.2617L11.4114 27.3933H0.875L6.1432 18.2617Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6836 18.2603L11.4154 21.2996L11.4154 15.2209L16.6836 18.2603Z",
    fill: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9473 15.2205L16.6791 18.2598L16.6791 12.1812L21.9473 15.2205Z",
    fill: "#FFCC00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4121 21.3015L16.6803 18.2622L16.6803 24.3408L11.4121 21.3015Z",
    fill: "#FFCC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9473 21.3003L16.6791 24.3396L16.6791 18.261L21.9473 21.3003Z",
    fill: "#FFCC00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4121 15.2217L16.6803 12.1823L16.6803 18.261L11.4121 15.2217Z",
    fill: "#FFCC00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6836 18.2615L21.9518 15.2221L21.9518 21.3008L16.6836 18.2615Z",
    fill: "#FFCC00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2142 18.2617L21.946 9.13018L32.4824 9.13018L27.2142 18.2617Z",
    fill: "url(#paint5_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2116 18.2617L32.4798 27.3933H21.9434L27.2116 18.2617Z",
    fill: "url(#paint6_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14001 18.2617L0.871813 9.13018L11.4082 9.13018L6.14001 18.2617Z",
    fill: "#FFCC00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6751 36.5295L11.4069 27.398L21.9434 27.398L16.6751 36.5295Z",
    fill: "#FFCC00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6764 9.0421e-07L21.9446 9.13154L11.4082 9.13154L16.6764 9.0421e-07Z",
    fill: "#FFCC00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.9613,
    y1: 9.13232,
    x2: 32.4977,
    y2: 27.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.86948,
    y1: 27.3909,
    x2: 0.872431,
    y2: 9.12779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16.6791,
    y1: 36.5281,
    x2: 27.2126,
    y2: 18.2651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 0.874999,
    y1: 9.14774,
    x2: 0.872049,
    y2: 27.3933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 11.4154,
    y1: 15.2047,
    x2: 14.0495,
    y2: 19.4895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113338,
    stopColor: "#FFCC00",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 21.9431,
    y1: 9.13018,
    x2: 32.4795,
    y2: 27.3933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 16.6722,
    y1: 36.5248,
    x2: 27.2116,
    y2: 18.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00",
    stopOpacity: 0.27
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstellationYellowLogo);
export default __webpack_public_path__ + "static/media/constellation-yellow-logo.a3bf3223cf57f3f23f575cedf36d4609.svg";
export { ForwardRef as ReactComponent };